export const LANGUAGES_OPTIONS = {
  EN: 'en',
  ES: 'es',
} as const

export type LanguagesTypes = (typeof LANGUAGES_OPTIONS)[keyof typeof LANGUAGES_OPTIONS]
